import { memo } from 'react';

import { Markdown } from '../../../Markdown';
import { Message } from '../../../ui';

type MembershipRegistrationProps = {
  registration: {
    content: string;
    shouldRegister: boolean;
  };
};

export const MembershipRegistration = memo(function MembershipRegistration({
  registration,
}: MembershipRegistrationProps) {
  const { content } = registration;

  return (
    <Message.BubbleGroup>
      <Message.Bubble>
        <Markdown>{content}</Markdown>
      </Message.Bubble>
    </Message.BubbleGroup>
  );
});
